<template>
  <div class="chat-welcome">

    <button
      class="btn-historico"
      v-if="acessoChatLiberado && mensagens.length === 0"
      title="Ver histórico de conversas"
      @click="historicoAberto = true"
    >
      <i class="bi bi-clock-history"></i>
    </button>

    <!-- Estado inicial: saudação centralizada -->
    <div class="chat-hero" v-if="mensagens.length === 0">
      <div class="hero-badge"><i class="bi bi-rocket-takeoff"></i></div>
      <h1>{{$t('bem_vindo')}} <span>{{$t('ginfo_analytics')}}</span></h1>
      <!-- <p>Pergunte pelo nome de um relatório ou dashboard que eu abro para você.</p> -->
      <p>{{ $t('informacoes_inteligentes') }}.</p>

      <div class="hero-suggestions d-none" v-if="sugestoesIniciais.length">
        <button
          class="chip"
          v-for="(link, i) in sugestoesIniciais"
          :key="i"
          @click="enviarPergunta(link.ds_link)"
        >
          <i :class="'bi ' + (link.ic_link || 'bi-bar-chart')"></i>
          {{ link.ds_link }}
        </button>
      </div>

      <div class="chat-input-bar" v-if="acessoChatLiberado">
        <div class="bi-seletor-row">
          <div class="bi-seletor">
            <button class="bi-seletor-btn" @click="seletorBiAberto = !seletorBiAberto">
              <i class="bi" :class="biSelecionado.icone"></i>
              <span>{{ biSelecionado.nome }}</span>
              <i class="bi bi-chevron-down seta-seletor" :class="{ aberta: seletorBiAberto }"></i>
            </button>

            <template v-if="seletorBiAberto">
              <div class="bi-seletor-backdrop" @click="seletorBiAberto = false"></div>
              <div class="bi-seletor-menu">
                <button
                  class="bi-seletor-item"
                  v-for="bi in bisDisponiveis"
                  :key="bi.id"
                  :class="{ ativo: bi.id === biSelecionado.id }"
                  @click="selecionarBi(bi)"
                >
                  <i class="bi" :class="bi.icone"></i>
                  <span>{{ bi.nome }}</span>
                  <i class="bi bi-check-lg check-item" v-if="bi.id === biSelecionado.id"></i>
                </button>
              </div>
            </template>
          </div>
        </div>

        <div class="chat-input-wrapper">
          <textarea
            ref="elTextarea"
            v-model="pergunta"
            rows="1"
            :disabled="carregandoResposta"
            placeholder="Pergunte sobre as ordens de serviço... ex: quais as 5 placas que mais geraram OS em julho?"
            @keydown.enter.exact.prevent="enviarPergunta()"
            @input="ajustarAlturaTextarea"
          ></textarea>
          <button class="btn-enviar" :disabled="!pergunta.trim() || carregandoResposta" @click="enviarPergunta()">
            <i class="bi bi-send-fill"></i>
          </button>
        </div>
        <span class="chat-hint">Enter para enviar</span>
      </div>

      <div class="recentes" v-if="recentes.length">
        <div class="scroll-hint d-none"><i class="bi bi-chevron-down"></i></div>
        <span class="recentes-label">{{$t('acessados_recentemente')}}</span>
        <div class="recentes-grid">
          <button
            class="recente-card"
            v-for="(link, i) in recentes"
            :key="i"
            @click="abrirRelatorio(link)"
          >
            <div class="recente-icon"><i :class="'bi ' + (link.ic_link || 'bi-bar-chart')"></i></div>
            <strong>{{ link.ds_link }}</strong>
            <small>{{ tempoRelativo(link.acessadoEm) }}</small>
          </button>
        </div>
      </div>
    </div>

    <!-- Histórico da conversa -->
    <template v-else>
      <div class="chat-header">
        <div class="chat-header-info">
          <img src="../assets/images/icon-gia.jpg" class="chat-header-avatar" alt="">
          <span>Conversa com a Gia</span>
        </div>
        <div class="chat-header-acoes">
          <button class="btn-historico-inline" title="Ver histórico de conversas" @click="historicoAberto = true">
            <i class="bi bi-clock-history"></i>
          </button>
          <button class="btn-fechar-chat" title="Fechar conversa e voltar ao início" @click="fecharChat">
            <i class="bi bi-x-lg"></i>
            <span>Fechar conversa</span>
          </button>
        </div>
      </div>

      <div class="chat-body" ref="chatBody">
        <div
          class="chat-msg"
          :class="msg.autor"
          v-for="(msg, i) in mensagens"
          :key="i"
        >
          <div class="avatar" v-if="msg.autor === 'bot'">
            <!-- <i class="bi bi-robot"></i> -->
             <img src="../assets/images/icon-gia.jpg" style="width: 34px; border-radius: 50px;" alt="">
          </div>

          <div class="bubble">
            <div v-if="msg.texto" class="texto-resposta" v-html="formatarResposta(msg.texto)"></div>

            <div class="tabela-dados" v-if="msg.dados && msg.dados.length">
              <table>
                <thead>
                  <tr>
                    <th v-for="(chave, c) in Object.keys(msg.dados[0])" :key="c">{{ formatarCabecalho(chave) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(linha, l) in msg.dados" :key="l">
                    <td v-for="(chave, c) in Object.keys(msg.dados[0])" :key="c">{{ linha[chave] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <button v-if="false" class="ver-detalhes" @click="$set(msg, 'mostrarDetalhes', !msg.mostrarDetalhes)">
              <i class="bi" :class="msg.mostrarDetalhes ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              {{ msg.mostrarDetalhes ? 'Ocultar detalhes técnicos' : 'Ver detalhes técnicos' }}
            </button>

            <div class="detalhes-tecnicos" v-if="msg.dax && msg.mostrarDetalhes">
              <p v-if="msg.dax.explicacao"><strong>Explicação:</strong> {{ msg.dax.explicacao }}</p>
              <p><strong>Consulta DAX utilizada:</strong></p>
              <pre>{{ msg.dax.utilizada || msg.dax.gerada }}</pre>
            </div>

            <div class="feedback-row" v-if="msg.autor === 'bot' && msg.mensagemId">
              <button
                class="btn-feedback"
                :class="{ ativo: msg.feedback === 1 }"
                title="Resposta útil"
                @click="avaliarResposta(msg, 1)"
              >
                <i class="bi" :class="msg.feedback === 1 ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'"></i>
              </button>
              <button
                class="btn-feedback"
                :class="{ ativo: msg.feedback === -1, negativo: msg.feedback === -1 }"
                title="Resposta não ajudou"
                @click="avaliarResposta(msg, -1)"
              >
                <i class="bi" :class="msg.feedback === -1 ? 'bi-hand-thumbs-down-fill' : 'bi-hand-thumbs-down'"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="chat-msg bot" v-if="carregandoResposta">
          <div class="avatar">
            <img src="../assets/images/icon-gia.jpg" style="width: 34px; border-radius: 50px;" alt="">
          </div>
          <div class="bubble bubble-status">
            <span class="typing"><span></span><span></span><span></span></span>
            <p class="status-texto">{{ statusCarregamento }}</p>
          </div>
        </div>
      </div>

      <div class="chat-input-bar">
        <div class="bi-seletor-row">
          <div class="bi-seletor">
            <button class="bi-seletor-btn" @click="seletorBiAberto = !seletorBiAberto">
              <i class="bi" :class="biSelecionado.icone"></i>
              <span>{{ biSelecionado.nome }}</span>
              <i class="bi bi-chevron-down seta-seletor" :class="{ aberta: seletorBiAberto }"></i>
            </button>

            <template v-if="seletorBiAberto">
              <div class="bi-seletor-backdrop" @click="seletorBiAberto = false"></div>
              <div class="bi-seletor-menu">
                <button
                  class="bi-seletor-item"
                  v-for="bi in bisDisponiveis"
                  :key="bi.id"
                  :class="{ ativo: bi.id === biSelecionado.id }"
                  @click="selecionarBi(bi)"
                >
                  <i class="bi" :class="bi.icone"></i>
                  <span>{{ bi.nome }}</span>
                  <i class="bi bi-check-lg check-item" v-if="bi.id === biSelecionado.id"></i>
                </button>
              </div>
            </template>
          </div>
        </div>

        <div class="chat-input-wrapper">
          <textarea
            ref="elTextarea"
            v-model="pergunta"
            rows="1"
            :disabled="carregandoResposta"
            placeholder="Pergunte sobre as ordens de serviço... ex: quais as 5 placas que mais geraram OS em julho?"
            @keydown.enter.exact.prevent="enviarPergunta()"
            @input="ajustarAlturaTextarea"
          ></textarea>
          <button class="btn-enviar" :disabled="!pergunta.trim() || carregandoResposta" @click="enviarPergunta()">
            <i class="bi bi-send-fill"></i>
          </button>
        </div>
        <span class="chat-hint">Enter para enviar</span>
      </div>
    </template>

    <chat-historico
      v-if="acessoChatLiberado && historicoAberto"
      @fechar="historicoAberto = false"
      @abrir-conversa="carregarConversaHistorico"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { flattenMenus, tempoRelativo } from '@/utils/relatorios'
import { BIS_DISPONIVEIS } from '@/common/api.js'
import ChatHistorico from '@/components/ChatHistorico.vue'

export default {
  name: 'HelloWorld',
  components: {
    ChatHistorico
  },
  data() {
    return {
      pergunta: '',
      mensagens: [],
      carregandoResposta: false,
      statusCarregamento: '',
      timersCarregamento: [],
      conversaEncerrada: false,
      conversaAtualId: null,
      historicoAberto: false,
      bisDisponiveis: BIS_DISPONIVEIS,
      biSelecionado: BIS_DISPONIVEIS[0],
      seletorBiAberto: false,
      // Começa escondido por padrão (fail closed) até confirmar com o backend que o
      // usuário está em bi_chat_usuarios_liberados. Sem acesso, a tela de boas-vindas
      // e os "acessados recentemente" continuam aparecendo normalmente — só a barra
      // de input do chat (e o histórico de conversas) ficam escondidos.
      acessoChatLiberado: false
    }
  },
  computed: {
    todosOsLinks() {
      return flattenMenus(this.$store.getters['busca/getMenus'])
    },
    sugestoesIniciais() {
      return this.todosOsLinks.slice(0, 4)
    },
    recentes() {
      return this.$store.getters['abas/recentes']
    }
  },
  async created() {
    this.acessoChatLiberado = await this.$store.dispatch('busca/verificarAcessoChat')
  },
  mounted() {
    this.$nextTick(() => this.ajustarAlturaTextarea())
    const host = window.location.hostname;

    if(host.includes('ginfo.io')) {
      this.$i18n.locale = 'en';
      this.open = false;

      const idiomaSelecionado = {
        lang: 'en'
      }
      localStorage.lang = JSON.stringify(idiomaSelecionado)
    }
  },
  beforeDestroy() {
    this.pararCarregamentoFaseado()
  },
  methods: {
    tempoRelativo,
    // Cresce o textarea suavemente conforme o texto ocupa mais linhas (até o
    // limite de max-height definido no CSS, onde passa a rolar em vez de crescer).
    ajustarAlturaTextarea() {
      const el = this.$refs.elTextarea
      if (!el) return
      el.style.height = 'auto'
      el.style.height = el.scrollHeight + 'px'
    },
    scrollParaBaixo() {
      this.$nextTick(() => {
        const el = this.$refs.chatBody
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    formatarResposta(texto) {
      const escapado = (texto || '')
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      return escapado
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/\n/g, '<br>')
    },
    formatarCabecalho(chave) {
      const match = chave.match(/\[(.+?)\]/)
      return match ? match[1] : chave
    },
    enviarPergunta(textoInicial) {
      const texto = (textoInicial !== undefined ? textoInicial : this.pergunta).trim()
      if (!texto || this.carregandoResposta) return

      this.mensagens.push({ autor: 'user', texto })
      this.pergunta = ''
      this.scrollParaBaixo()
      this.$nextTick(() => this.ajustarAlturaTextarea())

      this.perguntarIA(texto)
    },
    abrirRelatorio(link) {
      this.$store.dispatch('abas/abrirRelatorio', link)
    },
    // Trocar de BI no meio de uma conversa não faz sentido (cada conversa é
    // sobre um dataset/catálogo específico) — então fecha a atual antes de trocar.
    selecionarBi(bi) {
      const trocouDeBi = bi.id !== this.biSelecionado.id
      this.seletorBiAberto = false

      if (trocouDeBi && this.mensagens.length > 0) {
        this.fecharChat()
      }

      this.biSelecionado = bi
    },
    fecharChat() {
      this.conversaEncerrada = true
      this.pararCarregamentoFaseado()
      this.mensagens = []
      this.pergunta = ''
      this.conversaAtualId = null
    },
    // Carrega uma conversa salva a partir do histórico e continua ela dali —
    // as próximas perguntas dessa sessão entram na mesma conversa (conversaAtualId).
    async carregarConversaHistorico(conversa) {
      this.historicoAberto = false
      this.pararCarregamentoFaseado()
      this.conversaEncerrada = false

      try {
        const resultado = await this.$store.dispatch('busca/carregarMensagensConversa', {
          conversaId: conversa.nr_sequencial
        })

        this.conversaAtualId = resultado.conversaId

        // Reaplica o BI dessa conversa (pode ter sido criada com um BI diferente
        // do que está selecionado agora), pra próximas perguntas usarem o certo.
        const biDaConversa = this.bisDisponiveis.find(bi => bi.reportId === resultado.reportId)
        if (biDaConversa) this.biSelecionado = biDaConversa

        this.mensagens = resultado.mensagens || []
        this.pergunta = ''
        this.scrollParaBaixo()
        this.$nextTick(() => this.ajustarAlturaTextarea())
      } catch (error) {
        // Se falhar, só não abre nada — o usuário continua vendo a tela atual.
      }
    },
    // Clicar de novo no mesmo botão remove a avaliação (fica neutro outra vez).
    async avaliarResposta(msg, valor) {
      if (!msg.mensagemId) return

      const novoValor = msg.feedback === valor ? null : valor
      const valorAnterior = msg.feedback
      this.$set(msg, 'feedback', novoValor)

      try {
        await this.$store.dispatch('busca/avaliarMensagemChat', {
          mensagemId: msg.mensagemId,
          feedback: novoValor
        })
      } catch (error) {
        this.$set(msg, 'feedback', valorAnterior)
      }
    },
    iniciarCarregamentoFaseado() {
      this.carregandoResposta = true

      const fases = [
        'Pergunta recebida, iniciando a análise...',
        'Consultando os dados do relatório...',
        'Montando o compilado de informações...',
        'Quase lá, finalizando a resposta...',
        'Perguntas mais complexas podem levar alguns minutos, ainda trabalhando nisso...'
      ]
      const atrasos = [0, 4000, 12000, 25000, 45000]

      this.statusCarregamento = fases[0]

      fases.slice(1).forEach((texto, i) => {
        const timer = setTimeout(() => {
          if (this.carregandoResposta) this.statusCarregamento = texto
        }, atrasos[i + 1])

        this.timersCarregamento.push(timer)
      })
    },
    pararCarregamentoFaseado() {
      this.carregandoResposta = false
      this.statusCarregamento = ''
      this.timersCarregamento.forEach(timer => clearTimeout(timer))
      this.timersCarregamento = []
    },
    // Por enquanto o chat da tela inicial só responde sobre o relatório de
    // Ordem de Serviço (reportId fixo). Quando expandirmos para os demais
    // relatórios, este reportId deixa de ser fixo e passa a vir da escolha
    // do usuário/contexto da conversa.
    async perguntarIA(pergunta) {
      this.conversaEncerrada = false
      this.iniciarCarregamentoFaseado()

      try {
        const resultado = await this.$store.dispatch('busca/perguntarChatBI', {
          pergunta,
          reportId: this.biSelecionado.reportId,
          workspaceId: this.biSelecionado.workspaceId,
          conversaId: this.conversaAtualId
        })

        this.pararCarregamentoFaseado()
        if (this.conversaEncerrada) return

        if (resultado.conversaId) {
          this.conversaAtualId = resultado.conversaId
        }

        this.mensagens.push({
          autor: 'bot',
          mensagemId: resultado.mensagemId,
          texto: resultado.resposta,
          dados: resultado.dados,
          dax: (resultado.dax_gerada || resultado.dax_utilizada || resultado.explicacao) ? {
            gerada: resultado.dax_gerada,
            utilizada: resultado.dax_utilizada,
            explicacao: resultado.explicacao
          } : null,
          feedback: null,
          mostrarDetalhes: false
        })
        this.scrollParaBaixo()
      } catch (error) {
        this.pararCarregamentoFaseado()
        if (this.conversaEncerrada) return

        this.mensagens.push({
          autor: 'bot',
          texto: 'Não consegui obter uma resposta agora. Tente novamente em instantes.'
        })
        this.scrollParaBaixo()
      }
    }
  }
}
</script>

<style scoped>
.chat-welcome {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: var(--rd-text-1);
  position: relative;
  /* Fonte só do chat (não mexe no resto do app, que usa Poppins via App.vue).
     "Styrene" (a fonte real da interface do Claude) é licenciada pela Anthropic,
     não dá pra embutir num projeto de terceiros — Inter é a mais próxima
     gratuita nesse estilo, carregada via Google Fonts no index.html. */
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* ---------- Seletor de BI (logo acima do textarea) ---------- */
.bi-seletor-row {
  width: 100%;
  max-width: 720px;
  display: flex;
  margin-bottom: 8px;
}

.bi-seletor {
  position: relative;
}

.bi-seletor-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border);
  border-radius: 10px;
  padding: 7px 12px;
  color: var(--rd-text-1);
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s ease;
}

.bi-seletor-btn:hover {
  border-color: var(--rd-border-strong);
  background: var(--rd-hover);
}

.bi-seletor-btn i:first-child {
  color: #fff;
  font-size: 14px;
}

.seta-seletor {
  font-size: 10px;
  color: var(--rd-text-3);
  transition: transform 0.2s ease;
}

.seta-seletor.aberta {
  transform: rotate(180deg);
}

.bi-seletor-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: transparent;
}

.bi-seletor-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 41;
  min-width: 220px;
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-md, 12px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  padding: 6px;
}

.bi-seletor-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: none;
  border: none;
  border-radius: 8px;
  padding: 9px 10px;
  color: var(--rd-text-2);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: 0.15s ease;
}

.bi-seletor-item:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.bi-seletor-item.ativo {
  color: var(--rd-text-1);
  font-weight: 500;
}

.bi-seletor-item i:first-child {
  color: var(--rd-text-3);
  font-size: 14px;
}

.bi-seletor-item.ativo i:first-child {
  color: var(--rd-accent);
}

.bi-seletor-item span {
  flex: 1;
}

.check-item {
  color: var(--rd-accent) !important;
}

/* ---------- Botão de histórico (estado inicial, flutuante) ---------- */
.btn-historico {
  position: absolute;
  top: 14px;
  right: 20px;
  z-index: 10;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--rd-border-strong);
  background: var(--rd-bg-1);
  color: var(--rd-text-2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  transition: 0.2s ease;
}

.btn-historico:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

/* ---------- Hero (estado inicial) ---------- */
.chat-hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 35px 20px;
  overflow-y: auto;
}

.hero-badge {
  font-size: 34px;
  margin-bottom: 10px;
  color: var(--rd-accent);
}

.chat-hero h1 {
  font-size: 2.1rem;
  font-weight: 600;
  margin-bottom: 12px;
}

.chat-hero h1 span {
  background: linear-gradient(45deg, #2d9cdb, #41a838);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.chat-hero p {
  font-size: 1.05rem;
  color: var(--rd-text-2);
  margin-bottom: 30px;
}

.hero-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  max-width: 700px;
}

.chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border);
  color: var(--rd-text-1);
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease;
}

.chip:hover {
  background: var(--rd-accent);
  border-color: var(--rd-accent);
  transform: translateY(-2px);
}

/* ---------- Cabeçalho da conversa ---------- */
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--rd-border);
}

.chat-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--rd-text-2);
}

.chat-header-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
}

.chat-header-acoes {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-historico-inline {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid var(--rd-border);
  background: none;
  color: var(--rd-text-3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 13px;
  transition: 0.2s ease;
}

.btn-historico-inline:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
  border-color: var(--rd-border-strong);
}

.btn-fechar-chat {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1px solid var(--rd-border);
  border-radius: 20px;
  padding: 6px 12px;
  color: var(--rd-text-3);
  font-size: 12px;
  cursor: pointer;
  transition: 0.2s ease;
}

.btn-fechar-chat:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
  border-color: var(--rd-border-strong);
}

/* ---------- Corpo da conversa ---------- */
.chat-body {
  flex: 1;
  overflow-y: auto;
  padding: 30px 10px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.chat-msg {
  display: flex;
  gap: 12px;
  max-width: 720px;
}

.chat-msg.user {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.avatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: var(--rd-bg-1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.bubble {
  background: var(--rd-bg-1);
  border-radius: 16px;
  padding: 12px 16px;
  text-align: left;
  max-width: 100%;
}

.chat-msg.user .bubble {
  /* background: var(--rd-accent); */
  background: #333543;
}

.texto-resposta {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.bubble-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.link-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  border-radius: 10px;
  padding: 10px 12px;
  color: var(--rd-text-1);
  cursor: pointer;
  text-align: left;
  transition: 0.2s ease;
}

.link-card:hover {
  background: var(--rd-hover);
  border-color: var(--rd-accent);
}

.link-card-texto {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.link-card-texto small {
  color: var(--rd-text-3);
  font-size: 11px;
}

.seta {
  font-size: 20px;
}

.typing {
  display: inline-flex;
  gap: 4px;
}

.typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--rd-text-3);
  animation: piscar 1s infinite ease-in-out;
}

.typing span:nth-child(2) { animation-delay: 0.15s; }
.typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes piscar {
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
}

.bubble-status {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-texto {
  margin: 0;
  font-size: 13px;
  color: var(--rd-text-2);
}

/* ---------- Tabela de dados ---------- */
.tabela-dados {
  margin-top: 10px;
  max-height: 220px;
  overflow: auto;
  border: 1px solid var(--rd-border);
  border-radius: 8px;
}

.tabela-dados table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

.tabela-dados th,
.tabela-dados td {
  padding: 6px 10px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid var(--rd-border);
}

.tabela-dados th {
  position: sticky;
  top: 0;
  background: var(--rd-bg-2);
  color: var(--rd-text-2);
  font-weight: 500;
}

.tabela-dados tbody tr:last-child td {
  border-bottom: none;
}

/* ---------- Detalhes técnicos (DAX) ---------- */
.ver-detalhes {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  background: none;
  border: none;
  color: var(--rd-text-3);
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}

.ver-detalhes:hover {
  color: var(--rd-text-1);
}

.detalhes-tecnicos {
  margin-top: 8px;
  padding: 10px 12px;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border);
  border-radius: 8px;
}

.detalhes-tecnicos p {
  margin: 0 0 6px;
  font-size: 12px;
  color: var(--rd-text-2);
}

.detalhes-tecnicos pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 11.5px;
  font-family: var(--font-mono, monospace);
  color: var(--rd-text-1);
}

/* ---------- Feedback (👍/👎) ---------- */
.feedback-row {
  display: flex;
  gap: 4px;
  margin-top: 10px;
}

.btn-feedback {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: none;
  color: var(--rd-text-3);
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s ease;
}

.btn-feedback:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.btn-feedback.ativo {
  color: var(--rd-accent);
  background: var(--rd-hover);
}

.btn-feedback.ativo.negativo {
  color: #e5534b;
}

/* ---------- Barra de input ---------- */
.chat-input-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  width: 100%;
}

.chat-input-wrapper {
  width: 100%;
  max-width: 720px;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border-strong);
  border-radius: 22px;
  padding: 10px 10px 10px 20px;
}

.chat-input-wrapper textarea {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  color: var(--rd-text-1);
  font-size: 14px;
  max-height: 120px;
  overflow-y: auto;
  padding: 6px 0;
  font-family: inherit;
  transition: height 0.15s ease-out;
}

.chat-input-wrapper textarea:disabled {
  opacity: 0.5;
}

.chat-input-wrapper textarea::placeholder {
  color: var(--rd-text-3);
}

.btn-enviar {
  background: var(--rd-accent);
  border: none;
  color: #fff;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease;
}

.btn-enviar:disabled {
  background: var(--rd-border-strong);
  cursor: not-allowed;
}

.btn-enviar:not(:disabled):hover {
  opacity: 0.85;
}

.chat-hint {
  margin-top: 8px;
  font-size: 11px;
  color: var(--rd-text-3);
}

/* ---------- Últimos acessados ---------- */
.recentes {
  width: 100%;
  max-width: 720px;
  margin-top: 10px;
}

.scroll-hint {
  text-align: center;
  color: var(--rd-text-3);
  font-size: 16px;
  margin-bottom: 6px;
}

.recentes-label {
  display: block;
  text-align: left;
  color: var(--rd-text-3);
  font-size: 11px;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.recentes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
}

.recente-card {
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border);
  border-radius: 10px;
  padding: 12px;
  text-align: left;
  color: var(--rd-text-1);
  cursor: pointer;
  transition: 0.2s ease;
}

.recente-card:hover {
  border-color: var(--rd-accent);
  background: var(--rd-hover);
}

.recente-icon {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  background: var(--rd-hover);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--rd-text-2);
  font-size: 14px;
  margin-bottom: 8px;
}

.recente-card strong {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  margin-bottom: 2px;
}

.recente-card small {
  color: var(--rd-text-3);
  font-size: 10.5px;
}
</style>
